export function getFocusableElements(node: HTMLElement) {
  const elements = Array.from(
    node.querySelectorAll<HTMLElement>(
      'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
  );
  return elements.filter((element) => element.tabIndex !== -1);
}

export function isInIframe() {
  return window.self !== window.top;
}
